<template>
  <!-- 展商详情页面 -->
  <div class="page-container">
    <!-- 选项卡按钮 -->
    <div style="margin-bottom: 20px; text-align: left">
      <el-button
        round
        size="small"
        :class="{ changtype: changetype == 1 }"
        @click="changePage_detail()"
      >展商详情
      </el-button>
      <el-button
        round
        size="small"
        @click="changePage_relevant()"
        :class="{ changtype: changetype == 2 }"
      >展品信息
      </el-button>
    </div>

    <!-- 展商详情内容 -->
    <div v-if="changetype == 1">
      <!-- 统计数据区块 -->
      <div class="index-block">
        <div class="index-block-top">
          <!-- 数据统计卡片 -->
          <div class="index-top-right">
            <div class="page-card__header">
              <span style="font-weight: bold">
                {{ infoData.name }}
              </span>
            </div>

            <div style="margin: 25px 0; clear: both">
              <div style="height: 180px; margin: 0 20px; text-align: center">
                <el-row>
                  <el-col :span="6">
                    <div
                      style="font-size: 40px; color: #2a36b1; margin-top: 40px"
                    >
                      {{ infoData.invitation }}
                    </div>
                    <div
                      style="font-size: 14px; color: var(--border-color); line-height: 30px"
                    >
                      预约数
                    </div>
                  </el-col>

                  <el-col :span="6">
                    <div
                      style="font-size: 40px; color: #2a36b1; margin-top: 40px"
                    >
                      {{ infoData.view }}
                    </div>
                    <div
                      style="font-size: 14px; color: var(--border-color); line-height: 30px"
                    >
                      浏览数
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div
                      style="font-size: 40px; color: #2a36b1; margin-top: 40px"
                    >
                      {{ infoData.share }}
                    </div>
                    <div
                      style="font-size: 14px; color: var(--border-color); line-height: 30px"
                    >
                      转发数
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div
                      style="font-size: 40px; color: #2a36b1; margin-top: 40px"
                    >
                      {{ infoData.praise }}
                    </div>
                    <div
                      style="font-size: 14px; color: var(--border-color); line-height: 30px"
                    >
                      点赞数
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <!-- 人气展品TOP3 -->
          <div class="index-top-left">
            <div class="page-card__header">
              <span style="font-weight: bold">人气展品TOP3</span>
            </div>
            <div
              v-for="i in productList"
              :key="i.id"
              style="
                height: 78px;
                width: 300px;
                border-bottom: 1px solid var(--border-color);
              "
            >
              <div style="padding: 16px">
                <el-row>
                  <el-col :span="6">
                    <div style="width: 50px; height: 50px">
                      <el-image :src="productImg + i.img"></el-image>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div style="margin-left: 10px">
                      <div
                        style="
                          font-size: 14px;
                          font-weight: bold;
                          text-align: left;
                          height: 14px;
                          line-height: 14px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                      >
                        {{ i.title }}
                      </div>
                      <div style="clear: both">
                        <div class="type_p">分类：{{ i.type }}</div>
                        <div
                          style="
                            float: right;
                            font-size: 12px;
                            line-height: 40px;
                          "
                        >
                          浏览数：{{ i.view }}
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 基本信息和联系信息区块 -->
      <div style="max-width: 1200px; width: 100%; margin: 20px auto">
        <el-row :gutter="20">
          <!-- 基本信息 -->
          <el-col :span="12">
            <div class="page-card" style="min-height: 1000px">
              <div class="page-card__header">
                <span style="font-weight: bold; line-height: 32px">基本信息</span>
                <el-button
                  size="small"
                  type="danger"
                  @click="dialogForm = true"
                  style="float: right"
                >重置密码
                </el-button>
              </div>
              <div class="page-card__body" style="font-size: 14px">
                <el-form
                  :model="baseform"
                  :rules="rules"
                  ref="baseform"
                  label-width="100px"
                >
                  <el-row style="text-align: left" :gutter="16">
                    <el-col :span="5"> 公司LOGO：</el-col>
                    <el-col :span="4">
                      <el-image :src="img"></el-image>
                    </el-col>
                    <el-col :span="15">
                      <el-upload
                        class="avatar-uploader"
                        :action="imagesrc"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :headers="headers"
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" type="primary" round
                        >点击上传
                        </el-button>
                        <div slot="tip" class="el-upload__tip">
                          最佳展示尺寸：1:1，建议500 x 500像素
                        </div>
                      </el-upload>
                    </el-col>
                  </el-row>

                  <el-form-item
                    prop="username"
                    label="用户名："
                    style="margin-top: 20px"
                  >
                    <el-input
                      placeholder="填入登录用户名"
                      v-model="baseform.username"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="name"
                    label="公司名称："
                    style="margin-top: 20px"
                  >
                    <el-input
                      placeholder="填入公司名称"
                      v-model="baseform.name"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    prop="booth"
                    label="展位号："
                    style="margin-top: 20px"
                  >
                    <el-input
                      placeholder="展位号"
                      v-model="baseform.booth"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公司分类：" prop="type">
                    <el-checkbox-group v-model="type">
                      <el-checkbox label="紧固件"></el-checkbox>
                      <el-checkbox label="设备"></el-checkbox>
                      <el-checkbox label="模具"></el-checkbox>
                      <el-checkbox label="表面处理"></el-checkbox>
                      <el-checkbox label="原材料"></el-checkbox>
                      <el-checkbox label="检测"></el-checkbox>
                      <el-checkbox label="媒体"></el-checkbox>
                      <el-checkbox label="协会"></el-checkbox>
                      <el-checkbox label="其他"></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item prop="info" label="  公司简介：">
                    <el-input
                      type="textarea"
                      :rows="6"
                      v-model="baseform.info"
                      placeholder="请输入内容"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="product" label="主营产品：">
                    <el-input
                      type="textarea"
                      :rows="6"
                      v-model="baseform.product"
                      placeholder="请输入内容"
                    >
                    </el-input>
                  </el-form-item>

                  <el-row style="margin-top: 30px; text-align: center">
                    <el-button
                      round
                      size="small"
                      @click="onBaseSubmit('baseform')"
                      type="primary"
                    >
                      确定保存
                    </el-button>
                    <el-button
                      round
                      size="small"
                      @click="baseUpdate('baseform')"
                    >重置
                    </el-button>
                  </el-row>
                </el-form>
              </div>
            </div>
          </el-col>

          <!-- 联系信息 -->
          <el-col :span="12">
            <div class="page-card">
              <div class="page-card__header">
                <span style="font-weight: bold; line-height: 32px">联系信息</span>
              </div>
              <div class="page-card__body" style="text-align: left; font-size: 14px">
                <el-form
                  :model="contactsForm"
                  :rules="rules"
                  ref="contactsForm"
                  label-width="100px"
                >
                  <el-form-item prop="linkman" label="联系人：">
                    <el-input
                      placeholder="填入公司联系人"
                      v-model="contactsForm.linkman"
                    ></el-input>
                  </el-form-item>
                  <el-row style="margin-top: 20px" :gutter="10">
                    <el-col :span="12">
                      <el-form-item prop="mobile" label="手机：">
                        <el-input
                          maxlength="11"
                          placeholder="填入公司手机"
                          v-model="contactsForm.mobile"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="is_show_phone" label="公开手机号：">
                        <el-radio-group v-model="contactsForm.is_show_phone">
                          <el-radio :label="false">否</el-radio>
                          <el-radio :label="true">是</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row style="margin-top: 20px" :gutter="10">
                    <el-col :span="12">
                      <el-form-item prop="tel" label="电话：">
                        <el-input
                          placeholder="填入公司电话"
                          v-model="contactsForm.tel"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="email" label="邮箱：">
                        <el-input
                          placeholder="填入公司邮箱"
                          v-model="contactsForm.email"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="网址：">
                    <el-input
                      placeholder="填入公司网址"
                      v-model="contactsForm.website"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="地址：" prop="address">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="填入地址"
                      v-model="contactsForm.address"
                    ></el-input>
                  </el-form-item>

                  <el-row style="text-align: left" :gutter="16">
                    <el-form-item label="微信二维码：">
                      <el-col :span="8" v-if="contactsForm.wechat_qrcode">
                        <el-image :src="wx_chat_img"></el-image>
                      </el-col>
                      <el-col :span="8">
                        <el-upload
                          class="avatar-uploader"
                          :action="wxChatSrc"
                          :show-file-list="false"
                          :on-success="wxChatSuccess"
                          :headers="headers"
                          :before-upload="beforeAvatarUpload"
                        >
                          <el-button size="small" type="primary" round
                          >点击上传
                          </el-button>
                        </el-upload>
                      </el-col>
                    </el-form-item>
                  </el-row>

                  <el-row style="margin-top: 30px; text-align: center">
                    <el-button
                      round
                      size="small"
                      @click="contactsSubmit('contactsForm')"
                      type="primary"
                    >
                      确定保存
                    </el-button>
                    <el-button
                      round
                      size="small"
                      @click="contactUpdate('contactsForm')"
                    >重置
                    </el-button>
                  </el-row>
                </el-form>
              </div>
            </div>

            <!-- 展示视频区块 -->
            <div style="margin-top: 16px" class="page-card">
              <div class="page-card__header">
                <span style="font-weight: bold; line-height: 32px">展示视频</span>
              </div>
              <div class="page-card__body" style="text-align: left">
                <el-radio-group v-model="infoData.video_type">
                  <el-radio :label="1">上传视频源</el-radio>
                  <el-radio :label="2">上传腾讯视频链接</el-radio>
                </el-radio-group>
                <span
                  style="
                    color: #ff6000;
                    font-weight: bold;
                    font-size: 12px;
                    line-height: 20px;
                    margin-left: 30px;
                  "
                >*两个视频选项只能选择一个</span
                >
              </div>

              <div v-if="infoData.video_type === 1" style="padding: 20px">
                <el-row
                  style="text-align: left"
                  :gutter="16"
                  v-loading="loading"
                >
                  <el-col :span="12">
                    <div
                      :span="14"
                      v-if="infoData.video !== '' && infoData.video !== null"
                    >
                      <video
                        width="100%"
                        height="140"
                        :controls="controls"
                        :src="video"
                        :poster="videoImg"
                      ></video>
                    </div>
                    <div :span="14" v-else>
                      <el-image
                        src="/static/img/imgbg.png"
                        style="width: 100%; height: 140px"
                      ></el-image>
                    </div>
                    <div :span="8">
                      <el-upload
                        class="avatar-uploader"
                        :action="videoSrc"
                        :show-file-list="false"
                        :on-success="VideoSuccess"
                        :headers="headers"
                        :on-progress="progress"
                        :before-upload="beforeVideoUpload"
                        :on-error="videoError"
                      >
                        <el-button size="small" type="primary" round
                        >上传视频
                        </el-button>
                        <div slot="tip" class="el-upload__tip">
                          * 格式为.mp4的文件，大小不超过50MB
                        </div>
                      </el-upload>
                    </div>
                  </el-col>

                  <el-col :span="12">
                    <div :span="14">
                      <el-image
                        v-if="
                          infoData.video_img === '' ||
                          infoData.video_img === null
                        "
                        style="width: 270px; height: 140px"
                        src="/static/img/imgbg.png"
                      ></el-image>
                      <el-image
                        v-else
                        :src="videoImg"
                        fit="scale-down"
                        style="
                          width: 270px;
                          height: 140px;
                          border: 1px solid #999999;
                        "
                      ></el-image>
                    </div>
                    <div :span="8">
                      <el-upload
                        class="avatar-uploader"
                        :action="videoImagesrc"
                        :show-file-list="false"
                        :on-success="handleVideoSuccess"
                        :headers="headers"
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" type="primary" round
                        >上传封面
                        </el-button>
                        <div slot="tip" class="el-upload__tip">
                          * 建议封面尺寸：1080px X 720px
                        </div>
                      </el-upload>
                    </div>
                  </el-col>
                </el-row>

                <div style="padding: 20px 0; text-align: center">
                  <el-button
                    @click="videoBoth"
                    type="primary"
                    size="small"
                    style="width: 100px"
                  >保存
                  </el-button>
                  <br/>
                  <span
                    style="font-size: 12px; color: #ff6000; font-weight: bold"
                  >* 点击保存后视频和封面才会生效</span
                  >
                </div>
              </div>
              <div
                style="padding: 20px; height: 360px"
                v-else-if="infoData.video_type === 2"
              >
                <div style="text-align: left; padding: 10px 0; font-size: 14px">
                  输入腾讯视频链接
                </div>
                <el-input v-model="infoData.video_tx"></el-input>
                <p style="text-align: left; font-size: 12px">
                  * 例子：https://v.qq.com/x/page/f3309ndjx8b.html
                </p>
                <div style="padding: 20px 0">
                  <el-button
                    @click="sumbitVideoTx"
                    type="primary"
                    size="small"
                    style="width: 100px"
                  >保存
                  </el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 展品信息列表 -->
    <div v-else-if="changetype == 2">
      <div
        style="
          max-width: 1200px;
          width: 100%;
          min-height: auto;
          margin: 20px auto;
        "
        class="page-card"
      >
        <div class="page-card__header">
          <span style="font-weight: bold">{{ infoData.name }}的展品</span>
        </div>

        <div class="page-card__body">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="logo" label="产品图" width="80">
              <template slot-scope="scope">
                <el-image :src="productImg + scope.row.img"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="产品名"></el-table-column>

            <el-table-column prop="type" label="分类"></el-table-column>
            <el-table-column prop="view" label="浏览数" width="80">
            </el-table-column>
            <el-table-column prop="praise" label="点赞数" width="80">
            </el-table-column>
            <el-table-column prop="share" label="转发数" width="80">
            </el-table-column>

            <el-table-column prop="create_time" label="加入日期">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="handleClick(scope.row)"
                >查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页区域 -->
        <div style="margin: 20px 0; padding: 20px 0; text-align: center">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pagesize"
            :total="aSum"
            :page-count="pageCount"
            :current-page.sync="currentPage"
            background
            layout="prev, pager, next,jumper"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 重置密码弹窗 -->
    <el-dialog
      :title="infoData.name + ' 重置密码'"
      :visible.sync="dialogForm"
      :close-on-click-modal="false"
    >
      <el-form :model="passwordForm" :rules="rules" ref="passwordForm">
        <el-form-item prop="password" label="新密码：">
          <el-input
            placeholder="请填写新密码"
            v-model="passwordForm.password"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="againpassword" label="请再一次输入新密码：">
          <el-input
            placeholder="请再一次填写新密码"
            v-model="passwordForm.againpassword"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" round @click="updatePassword('passwordForm')"
          >确定修改
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {
    data() {
      let iphoneNumber = (rule, value, callback) => {
        let reg = /1[0-9]{10}$/;
        setTimeout(() => {
          if (!value) {
            return callback(new Error("号码不能为空"));
          } else {
            if (!reg.test(value)) {
              callback(new Error("检查你的号码"));
            } else {
              callback();
            }
          }
        }, 500);
      };
      let emailNumber = (rule, value, callback) => {
        let reg =
          /[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/;
        setTimeout(() => {
          if (!value) {
            return callback(new Error("邮箱不能为空"));
          } else {
            if (!reg.test(value)) {
              callback(new Error("检查你的邮箱格式"));
            } else {
              callback();
            }
          }
        }, 500);
      };
      return {
        id: "",
        cid: "",
        infoData: [],
        productList: [],
        img: "",
        controls: true,
        dialogForm: false,
        headers: {Authorization: "JWT " + localStorage.getItem("adminToken")},
        imagesrc: this.baseUrl + "/user/uploadfile/logo/",
        videoImagesrc: this.baseUrl + "/user/uploadfile/video_img/",
        wxChatSrc: this.baseUrl + "/user/uploadfile/wxchat/",
        videoSrc: this.baseUrl + "/user/uploadfile/video/",
        imgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/logo/",
        videoUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/video/",
        wx_chat_Url:
          "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/wxchat/",
        productImg:
          "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product/",
        video_imgUrl:
          "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/video_img/",
        loading: false,
        type: [],
        videoImg: "",
        wx_chat_img: "",
        video: "",
        video_tx: "",
        videoLink: "",
        changetype: 1,
        changeID: 0,
        baseInfoShow: true,
        contactInfoShow: true,
        videoShow: true,
        coname: "",
        baseform: {
          logo: "",
          name: "",
          type: [],
          info: "",
          product: "",
          booth: "",
          username: "",
        },
        contactsForm: {
          linkman: "",
          mobile: "",
          tel: "",
          website: "",
          address: "",
          email: "",
          wechat_qrcode: "",
        },
        passwordForm: {
          password: "",
          againpassword: "",
        },
        form: {},
        tableData: [],
        rules: {
          name: [{required: true, message: "请输入公司名", trigger: "blur"}],
          info: [{required: true, message: "请输入简介", trigger: "blur"}],
          product: [{required: true, message: "请输入产品", trigger: "blur"}],
          username: [
            {required: true, message: "请输入登录用户名", trigger: "blur"},
          ],
          linkman: [{required: true, message: "请输入联系人", trigger: "blur"}],
          mobile: [{required: true, validator: iphoneNumber, trigger: "blur"}],
          address: [{required: true, message: "请输入地址", trigger: "blur"}],
          tel: [{required: true, message: "请输入电话号码", trigger: "blur"}],
          email: [{required: true, validator: emailNumber, trigger: "blur"}],
          booth: [{required: true, message: "请输入展位号", trigger: "blur"}],

          password: [
            {required: true, message: "请输入新密码", trigger: "blur"},
          ],
          againpassword: [
            {required: true, message: "请再次输入新密码", trigger: "blur"},
          ],
        },
        // 分页相关数据
        aSum: 0,
        currentPage: 1,
        pageCount: 1,
        pagesize: 10,
      };
    },
    mounted() {
      // 初始化加载展商详情、展品列表等数据
      this.id = this.$route.query.id;
      this.getinfo();
      this.datalist();
      this.getProduct();
    },
    methods: {
      // 获取展商详情信息
      getinfo() {
        let id = this.id;
        let url = this.baseUrl + "/admin/users/" + id + "/";
        api.fetchData(url).then((res) => {
          this.infoData = res;
          if (this.infoData.video_type !== 1 && this.infoData.video_type !== 2) {
            this.infoData.video_type = 1;
          }
          this.cid = res.cid;
          this.img = this.imgUrl + this.infoData.logo;
          this.videoImg = this.video_imgUrl + this.infoData.video_img;
          this.wx_chat_img = this.wx_chat_Url + this.infoData.wechat_qrcode;
          this.video = this.videoUrl + this.infoData.video;
          this.baseform = res;
          this.type = res.type;
          if (this.type !== "" && this.type !== null) {
            this.type = this.type.split(",");
          } else {
            this.type = [];
          }

          this.contactsForm = res;
        });
      },

      // 获取人气展品TOP3
      getProduct() {
        let id = this.id;
        let url =
          this.baseUrl +
          "/admin/products/?ordering=-praise&user=" +
          id +
          "&size=3";

        api.fetchData(url).then((res) => {
          this.productList = res.results;
        });
      },

      // 获取展品列表数据
      datalist() {
        let id = this.id;

        let url = this.baseUrl + "/admin/products/?user=" + id;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      // 分页切换处理
      handleCurrentChange(val) {
        let id = this.id;
        let url = this.baseUrl + "/admin/products/?user=" + id + "&page=" + val;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      // 修改密码
      updatePassword(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            if (this.passwordForm.password === this.passwordForm.againpassword) {
              let id = this.id;
              let url = this.baseUrl + "/admin/update_password/" + id + "/";
              api
                .putData(url, {
                  password: this.passwordForm.password,
                })
                .then((res) => {
                  if (res.status === 200) {
                    this.$message({
                      showClose: true,
                      message: "修改成功",
                      type: "success",
                    });
                    this.passwordForm.password = "";
                    this.passwordForm.againpassword = "";
                  } else {
                    this.$message({
                      showClose: true,
                      message: "修改失败",
                      type: "warning",
                    });
                  }
                });
            } else {
              this.$message({
                message: "两次输入的密码不一致",
                type: "warning",
              });
            }
          }
        });
      },

      // 提交基本信息表单
      onBaseSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let id = this.id;
            let url = this.baseUrl + "/admin/users/" + id + "/";
            this.baseform.type = this.type.toString();
            api
              .patchData(url, {
                logo: this.baseform.logo,
                name: this.baseform.name,
                type: this.baseform.type,
                info: this.baseform.info,
                product: this.baseform.product,
                booth: this.baseform.booth,
                username: this.baseform.username,
              })
              .then((res) => {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.getinfo();
              });
          }
        });
      },

      // 提交联系信息表单
      contactsSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let id = this.id;
            let url = this.baseUrl + "/admin/users/" + id + "/";

            api
              .patchData(url, {
                linkman: this.contactsForm.linkman,
                mobile: this.contactsForm.mobile,
                tel: this.contactsForm.tel,
                website: this.contactsForm.website,
                address: this.contactsForm.address,
                email: this.contactsForm.email,
                wechat_qrcode: this.contactsForm.wechat_qrcode,
                is_show_phone:this.contactsForm.is_show_phone,
              })
              .then((res) => {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.getinfo();
              });
          }
        });
      },

      // 提交腾讯视频链接
      sumbitVideoTx() {
        let id = this.id;
        let url = this.baseUrl + "/admin/users/" + id + "/";
        let video_type = 2;
        let video_tx = this.infoData.video_tx;
        api
          .patchData(url, {
            video_tx: video_tx,
            video_type: video_type,
          })
          .then((res) => {
            this.getinfo();
            this.$message({
              message: "上传成功",
              type: "success",
            });
          });
      },

      // 图片上传成功回调
      handleAvatarSuccess(res, file) {
        this.baseform.logo = res.filename;
        this.img = this.imgUrl + this.baseform.logo;
      },

      // 微信二维码上传成功回调
      wxChatSuccess(res, file) {
        this.contactsForm.wechat_qrcode = res.filename;
        this.wx_chat_img = this.wx_chat_Url + this.contactsForm.wechat_qrcode;
      },

      // 视频上传成功回调
      VideoSuccess(res, file) {
        this.video = this.videoUrl + res.filename;
        this.infoData.video = res.filename;
        this.loading = false;
      },

      // 保存视频和封面
      videoBoth() {
        let id = this.id;
        let video_type = 1;
        let url = this.baseUrl + "/admin/users/" + id + "/";

        api
          .patchData(url, {
            video_img: this.infoData.video_img,
            video: this.infoData.video,
            video_type: video_type,
          })
          .then((res) => {
            this.getinfo();
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.loading = false;
          });
      },

      // 视频上传失败回调
      videoError(res, file) {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
        this.loading = false;
      },

      // 视频封面上传成功回调
      handleVideoSuccess(res, file) {
        this.videoImg = this.video_imgUrl + res.filename;
        this.infoData.video_img = res.filename;
      },

      // 视频上传前校验
      beforeVideoUpload(file) {
        const isVideo = file.type === "video/mp4";
        const isVideo50M = file.size / 1024 / 1024 < 50;
        if (!isVideo) {
          this.$message.error("上传视频只能是 MP4 格式!");
        }
        if (!isVideo50M) {
          this.$message.error("上传视频大小不能大于50M!");
        }
        return isVideo && isVideo50M;
      },

      // 视频上传进度处理
      progress() {
        this.loading = true;
      },

      // 图片上传前校验
      beforeAvatarUpload(file) {
      },

      // 切换到展商详情视图
      changePage_detail() {
        this.changetype = 1;
      },

      // 切换到展品信息视图
      changePage_relevant() {
        this.changetype = 2;
      },

      // 切换到备注视图
      changePage_remarks() {
        this.changetype = 3;
      },

      // 重置基本信息表单
      baseUpdate(formName) {
        this.$refs[formName].resetFields();
        this.getinfo();
      },

      // 重置联系信息表单
      contactUpdate(formName) {
        this.$refs[formName].resetFields();
        this.getinfo();
      },

      // 切换视频展示状态
      uploadVideo() {
        this.videoShow = this.videoShow === true ? false : true;
      },

      // 跳转到产品详情页
      handleClick(row) {
        this.$router.push({name: "admin_productDetail", query: {id: row.id}});
      },
    },
  };
</script>

<style scoped>
  .index-block {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
  }

  .index-block-top {
    max-width: 1200px;
    width: 100%;
    height: 300px;
    clear: both;
  }

  .index-block-bottom {
    clear: both;
    margin: 20px 0;
    max-width: 1200px;
    width: 100%;
    height: 300px;
  }

  .index-top-left {
    width: 300px;
    height: 300px;
    background-color: white;
    border-radius: 20px;
    float: left;
  }

  .index-top-right {
    width: 880px;
    height: 300px;
    background-color: white;
    margin-right: 20px;
    float: left;
    border-radius: 20px;
  }

  .apply-bottom-left {
    width: 300px;
    height: auto;
    min-height: 300px;
    background-color: white;
    border-radius: 20px;
    float: left;
  }

  .apply-bottom-right {
    width: 880px;
    height: auto;
    border-radius: 20px;
    background-color: white;
    margin-right: 20px;
    float: left;
  }

  .changtype {
    background-color: var(--color-primary);
    color: white;
  }

  .type_p {
    float: left;
    font-size: 12px;
    line-height: 40px;
    width: 100px;
    height: 40px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/exhibitorDetails.vue